module.exports = __webpack_public_path__ + "img/bg-cadastro-bike.3b719de3.svg";